import React, { useEffect } from "react";
import Container from "../../components/Container";
import Navbar from "../../components/Navbar";
import AssignmentAddForm from "../../components/assignment/AssignmentAddForm";

export default function AddAssignment() {
  useEffect(() => {
    document.title = "Add new Assignment";
  });
  return (
    <>
      <Navbar />
      <Container>
        <main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
          <h1 className="mt-4 mb-8 text-3xl font-bold text-center text-gray-800">
            Add Assignment
          </h1>
          <AssignmentAddForm />
        </main>
      </Container>
    </>
  );
}
